// @flow

import {
  type MultiChoiceState,
  checkBoxStatus,
} from './types';
import {
  learningOrder,
} from '../types';

const initialState: MultiChoiceState = {
  reviewCheckBoxStatus: {
    incorrect: checkBoxStatus.unchecked,
    correct: checkBoxStatus.unchecked,
  },
  reviewQuestions: [],
  correctStatus: false,
  currentQuestionAnswered: false,
  inReverseMode: false,
  isSessionComplete: false,
  isLastQuestionVisible: false,
  contextId: null,
  endTime: null,
  selectedChoiceIds: [],
  uniqueAnswers: {},
  sessionId: null,
  startTime: null,
  scheduleId: null,
  summary: null,
  currentIndex: 0,
  requestedQuestionsCount: 0,
  lastSeenIndex: 0,
  answeredFacts: {},
  inReviewMode: false,
  progressData: {
    target: [],
    answered: [],
    skipped: [],
  },
  choiceStatuses: {},
  answers: [],
  events: [],
  questions: [],
  timesChanged: [],
  sessionCreated: false,
  sessionLoading: false,
  learningOrder: learningOrder.LINEAR,
  reviewedContents: [],
  hasMore: false,
  sessionMeta: {},
  addedTaskIds: [],
};

export {
  // eslint-disable-next-line import/prefer-default-export
  initialState,
};
